export const Light = () => (
    <svg className='w-8 h-8 text-white' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
        <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z'
        />
    </svg>
)

export const Dark = () => (
    <svg className='w-8 h-8 text-white' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
        <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z'
        />
    </svg>
)

export const Code = () => (
    <svg className='w-8 h-8 text-white' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4' />
    </svg>
)

export const Github = () => (
    <svg
        className='w-8 h-8 p-1'
        fill='white'
        version='1.1'
        id='Capa_1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 478.613 478.613'
        style={{ enableBackground: 'new 0 0 478.613 478.613' }}
        xmlSpace='preserve'>
        <g id='XMLID_122_'>
            <g>
                <path
                    d='M427.501,200.695c1.776-11.238,2.884-23.56,3.163-37.377c-0.107-59.246-28.468-80.21-33.925-90.038
			c8.037-44.89-1.331-65.309-5.688-72.299c-16.07-5.704-55.91,14.722-77.678,29.101c-35.491-10.389-110.494-9.375-138.621,2.689
			C122.856-4.389,95.408,1.277,95.408,1.277s-17.745,31.82-4.691,78.371c-17.075,21.759-29.802,37.143-29.802,77.949
			c0,9.773,0.607,19.008,1.637,27.893c14.705,77.318,75.97,110.674,136.15,116.426c-9.056,6.881-19.928,19.903-21.432,34.992
			c-11.379,7.357-34.268,9.789-52.067,4.193c-24.939-7.88-34.486-57.266-71.833-50.221c-8.081,1.512-6.475,6.842,0.523,11.386
			c11.378,7.38,22.094,16.554,30.354,36.185c6.344,15.072,19.687,41.982,61.873,41.982c16.747,0,28.477-1.979,28.477-1.979
			s0.319,38.406,0.319,53.385c0,17.238-23.264,22.078-23.264,30.348c0,3.289,7.7,3.601,13.888,3.601
			c12.229,0,37.673-10.186,37.673-28.103c0-14.237,0.227-62.081,0.227-70.46c0-18.307,9.811-24.136,9.811-24.136
			s1.201,97.727-2.361,110.829c-4.177,15.408-11.744,13.219-11.744,20.076c0,10.233,30.589,2.502,40.735-19.897
			c7.849-17.495,4.334-113.331,4.334-113.331l8.183-0.178c0,0,0.094,43.892-0.188,63.944c-0.295,20.769-2.438,47.025,9.898,59.417
			c8.097,8.15,32.903,22.451,32.903,9.382c0-7.574-17.371-13.833-17.371-34.353V344.45c10.553,0,12.734,31.072,12.734,31.072
			l3.804,57.727c0,0-2.526,21.065,22.756,29.856c8.925,3.126,28.018,3.976,28.913-1.271c0.897-5.26-22.99-13.038-23.217-29.342
			c-0.123-9.93,0.445-15.742,0.445-58.934c0-43.168-5.799-59.137-26.007-71.863C355.669,295.681,416.536,269.51,427.501,200.695z'
                />
            </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
)

export const Api = () => (
    <svg
        className='w-8 h-8'
        fill='white'
        version='1.1'
        id='Capa_1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 368 368'
        style={{ enableBackground: 'new 0 0 368 368' }}
        xmlSpace='preserve'>
        <g>
            <g>
                <path
                    d='M88,128.001H56c-13.232,0-24,10.768-24,24v80c0,4.416,3.576,8,8,8s8-3.584,8-8v-24h48v24c0,4.416,3.576,8,8,8s8-3.584,8-8
			v-80C112,138.769,101.232,128.001,88,128.001z M96,192.001H48v-40c0-4.408,3.584-8,8-8h32c4.416,0,8,3.592,8,8V192.001z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M192,128.001h-32c-4.424,0-8,3.584-8,8v96c0,4.416,3.576,8,8,8s8-3.584,8-8v-24h24c22.056,0,40-17.944,40-40
			C232,145.945,214.056,128.001,192,128.001z M192,192.001h-24v-48h24c13.232,0,24,10.768,24,24S205.232,192.001,192,192.001z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M328,224.001h-24v-80h24c4.424,0,8-3.584,8-8s-3.576-8-8-8h-64c-4.424,0-8,3.584-8,8s3.576,8,8,8h24v80h-24
			c-4.424,0-8,3.584-8,8c0,4.416,3.576,8,8,8h64c4.424,0,8-3.584,8-8C336,227.585,332.424,224.001,328,224.001z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M344,48.001H219.312l-29.656-29.656c-3.128-3.128-8.184-3.128-11.312,0l-29.656,29.656H24c-13.232,0-24,10.768-24,24v24
			c0,4.416,3.576,8,8,8s8-3.584,8-8v-24c0-4.408,3.584-8,8-8h128c2.128,0,4.16-0.84,5.656-2.344L184,35.313l26.344,26.344
			c1.496,1.504,3.528,2.344,5.656,2.344h128c4.416,0,8,3.592,8,8v24c0,4.416,3.576,8,8,8s8-3.584,8-8v-24
			C368,58.769,357.232,48.001,344,48.001z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M360,264.001c-4.424,0-8,3.584-8,8v24c0,4.408-3.584,8-8,8H216c-2.128,0-4.16,0.84-5.656,2.344L184,332.689
			l-26.344-26.344c-1.496-1.504-3.528-2.344-5.656-2.344H24c-4.416,0-8-3.592-8-8v-24c0-4.416-3.576-8-8-8s-8,3.584-8,8v24
			c0,13.232,10.768,24,24,24h124.688l29.656,29.656c1.56,1.56,3.608,2.344,5.656,2.344c2.048,0,4.096-0.784,5.656-2.344
			l29.656-29.656H344c13.232,0,24-10.768,24-24v-24C368,267.585,364.424,264.001,360,264.001z'
                />
            </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
)

export const Close = () => (
    <svg className='w-8 h-8 text-purple-500' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
    </svg>
)

export const Play = () => (
    <svg className='w-10 h-10 text-white' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
        <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z'
        />
        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 12a9 9 0 11-18 0 9 9 0 0118 0z' />
    </svg>
)

export const Pause = () => (
    <svg className='w-10 h-10 text-white' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z' />
    </svg>
)

export const Stop = () => (
    <svg className='w-10 h-10 text-white' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 12a9 9 0 11-18 0 9 9 0 0118 0z' />
        <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z'
        />
    </svg>
)

export const Refresh = () => (
    <svg className='w-10 h-10 text-white' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
        <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M 4 19.998 L 4 14.998 L 4.582 14.998 M 19.938 12.998 C 19.169 19.109 12.073 22.096 7.165 18.374 C 6.015 17.502 5.123 16.336 4.582 14.998 M 4.582 14.998 L 9 14.998 M 20 3.998 L 20 8.998 L 19.419 8.998 M 19.419 8.998 C 17.106 3.288 9.479 2.224 5.69 7.082 C 4.805 8.217 4.243 9.57 4.062 10.998 M 19.419 8.998 L 15 8.998'
            transform='matrix(-1, 0, 0, -1, 24, 24.007215)'
        />
    </svg>
)
